export enum WorkerRole {
  READ_ONLY = 'Lese',
  TIMER = 'Tidtaker (Devent App)',
  TIMER_GATE = 'Devent Timergate',
  WRITER = 'Skriver',
  CALLER = 'Innroper',
}
